import { createFileRoute } from '@tanstack/react-router'
import HomePage from '#/pages/HomePage'
import { coursesQueryOptions } from '#/features/courses/hooks/useCourses'
import { testimonialsQueryOptions } from '#/features/home/hooks/useTestimonials'
import { blogsQueryOptions } from '#/features/blogs/hooks/useBlogs'
import hero3 from '#/assets/home/hero3.webp'
import hero3Mobile from '#/assets/home/hero3-mobile.webp'
import foregroundImage1 from '#/assets/home/foreground-image1.webp'

export const Route = createFileRoute('/_home/')({
  loader: async ({ context: { queryClient } }) => {
    await Promise.all([
      queryClient.ensureQueryData(coursesQueryOptions({ page: 1, limit: 3 })),
      queryClient.ensureQueryData(testimonialsQueryOptions()),
      queryClient.ensureQueryData(blogsQueryOptions({ limit: 3 })),
    ])
  },
  head: () => ({
    meta: [
      {
        title: "Online Quran Classes for Kids & Adults | Wa'allamah",
      },
      {
        name: 'description',
        content:
          'Learn Quran & Islamic studies online for kids & adults with qualified tutors. Enjoy 1-on-1 classes built for US & Canada schedules. Claim your free trial!',
      },
      {
        property: 'og:title',
        content: "Online Quran Classes for Kids & Adults | Wa'allamah",
      },
      {
        property: 'og:description',
        content:
          'Learn Quran & Islamic studies online for kids & adults with qualified tutors. Enjoy 1-on-1 classes built for US & Canada schedules. Claim your free trial!',
      },
      {
        name: 'twitter:title',
        content: "Online Quran Classes for Kids & Adults | Wa'allamah",
      },
      {
        name: 'twitter:description',
        content:
          'Learn Quran & Islamic studies online for kids & adults with qualified tutors. Enjoy 1-on-1 classes built for US & Canada schedules. Claim your free trial!',
      },
    ],
    links: [
      {
        rel: 'preload',
        as: 'image',
        type: 'image/webp',
        href: hero3Mobile,
        media: '(max-width: 768px)',
        fetchPriority: 'high',
      },
      {
        rel: 'preload',
        as: 'image',
        type: 'image/webp',
        href: hero3,
        media: '(min-width: 769px)',
        fetchPriority: 'high',
      },
      {
        rel: 'preload',
        as: 'image',
        type: 'image/webp',
        href: foregroundImage1,
        fetchPriority: 'high',
      },
    ],
  }),
  component: HomePage,
})
